var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorList',{attrs:{"no-border":true,"errors":_vm.admin_node_errorlogs,"loading":_vm.$apollo.queries.admin_node_errorlogs.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }